import React from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Link,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import theme from '../theme';
import { Container } from '@mui/system';

const PrivacyPolicy = () => {
  const sections = [
    {
      title: '1. Rol de Prestobots en el tratamiento de tus datos',
      content: (
        <>
          <Typography mb={1} align="justify">
            Prestobots brinda servicios a empresas para automatizar procesos tanto internos como
            externos, como podrían ser, entre muchas otras, comunicaciones con el usuario a través
            de aplicaciones de mensajes, gestión y procesamiento de transacciones, etc.{' '}
          </Typography>
          <Typography mb={1} align="justify">
            Por lo cual, más allá de que Prestobots no presta servicios en forma directa hacia los
            consumidores finales, en la operatoria diaria de su actividad, trata datos personales de
            los clientes que realizan gestiones ante las empresas que utilizan nuestros servicios.{' '}
          </Typography>
          <Typography mb={1} align="justify">
            Prestobots trabaja con varias empresas y, si las políticas de privacidad de dichas
            empresas te han traído a esta página a través de un link o redirección, significa que
            nosotros podemos llegar a realizar el tratamiento de ciertos datos personales que vos le
            brindas a esa empresa a través de nuestros servicios o que nos puede proporcionar la
            propia empresa.
          </Typography>
        </>
      ),
    },
    {
      title: '2. Datos que se recolectan',
      content: (
        <>
          <Typography variant="body1" align="justify">
            Prestobots puede recolectar datos personales que proporcione el usuario en forma directa
            a través de nuestros servicios, aquellos que haya proporcionado a la empresa que utiliza
            nuestros servicios o incluso aquellos datos y/o metadatos que sean proporcionados por el
            medio que se esté utilizando. <br />
            <br /> Los tipos de datos que Prestobots podrá recolectar son los son los siguientes:
          </Typography>
          <ul style={{ paddingLeft: '1.5rem', marginTop: '1rem' }}>
            <li>Nombre y Apellido</li>
            <li>Nombre de usuario o dato que identifique al usuario en la plataforma utilizada</li>
            <li>DNI</li>
            <li>Género</li>
            <li>Correo electrónico</li>
            <li>Número de teléfono</li>
            <li>Fecha de nacimiento</li>
            <li>Contenido de los mensajes</li>
            <li>
              Cualquier otro tipo de dato que sea solicitado al usuario durante la utilización de
              nuestros servicios
            </li>
          </ul>
        </>
      ),
    },
    {
      title: '3. Tratamiento de datos',
      content: (
        <>
          <Typography variant="body1" align="justify">
            La recolección y tratamiento de tu información personal permite a Prestobots brindar un
            servicio más eficiente para atender las necesidades del usuario. <br />
            <br />
            Éstos podrán ser los usos que le daremos a la información que nos brindes.
          </Typography>
          <ol style={{ paddingLeft: '1.5rem', marginTop: '1rem' }}>
            <li>
              Comunicación de dichos datos con la empresa que esté utilizando nuestros servicios
              para satisfacer las necesidades del usuario.
            </li>
            <li>
              Recolección y conservación de datos a los efectos de generar registros de fácil
              consulta por parte de las empresas que hagan uso de nuestros servicios.
            </li>
            <li>
              Disociación de datos y anonimización de los mismos a los efectos del análisis y
              mejoramiento en la prestación de nuestros servicios.
            </li>
            <li>
              Generación de tickets de acuerdo a la gestión solicitada por el usuario y seguimiento
              de la mencionada operación.
            </li>
            <li>
              Generación de mensajes automáticos relativos a las consultas realizadas por los
              usuarios.
            </li>
            <li>Envío de mensajes a los usuarios.</li>
          </ol>
          <Typography mb={1} align="justify">
            Prestobots podrá realizar cambios en los presentes términos y condiciones para ampliar
            el tratamiento que se le realizará a los presentes datos.{' '}
          </Typography>
          <Typography align="justify">
            Prestobots mantendrá el registro de tus datos personales durante el plazo que sea
            necesario para cumplir con los fines para los cuales fueron recolectados.
          </Typography>
        </>
      ),
    },
    {
      title: '4. Transmisión de Información',
      content: (
        <>
          <Typography mb={1} align="justify">
            En Prestobots nos tomamos tu privacidad muy en serio. Por ello, no vendemos ni
            comercializamos datos personales que identifiquen a nuestros usuarios. Tampoco
            compartimos o transferimos de ningún otro modo tu información personal a terceros, salvo
            de la manera indicada a continuación.{' '}
          </Typography>
          <Typography mb={1} align="justify">
            Prestobots podrá ceder, transmitir y/o transferir tu información personal a:
          </Typography>
          <Typography mb={1} align="justify">
            <u>Proveedores de Servicios:</u> Para poder brindar nuestro servicio, nos tenemos que
            valer de servicios de terceros ajenos a nosotros, tales como podrían ser pero no
            limitados a: proveedores de servicios de almacenamiento y procesamiento en la nube, etc.
            Nos aseguramos de que dichos servicios cumplan con nuestros estándares de protección de
            información y confidencialidad de la misma. Estos proveedores de servicios sólo acceden
            a la información estrictamente necesaria para prestar los servicios acordados y no
            pueden usarlos para finalidades distintas para las que se los encomendamos.{' '}
          </Typography>
          <Typography mb={1} align="justify">
            <u>Usuarios:</u> Tal como hemos venido explicando a lo largo de esta política, nosotros
            no prestamos un servicio directamente al usuario, sino que prestamos servicios a
            empresas que vinculan sus servicios con los nuestros y de esta forma entramos en
            contacto con el usuario final. Al estar brindándoles un servicio a ellos, compartimos la
            información que brindas a los efectos de que vos puedas realizar la gestión que desees.
          </Typography>
          <Typography mb={1} align="justify">
            Al utilizar los servicios de las empresas con las cuales contrates prestas tu
            consentimiento expreso e informado para que Prestobots ceda, transmita o transfiera tu
            información personal a los destinatarios detallados en esta Política de Privacidad.
          </Typography>
          <Typography mb={1} align="justify">
            Prestobots no será responsable por el uso indebido de tu información personal que haga
            cualquier tercero cuando sean estos terceros quienes directamente recolecten y/o traten
            tu información personal.
          </Typography>
        </>
      ),
    },
    {
      title: '5. Transferencias internacionales de datos',
      content: (
        <>
          <Typography mb={1} align="justify">
            Los servicios que brinda Prestobots requieren de una infraestructura tecnológica
            compleja, tales como servidores y servicios en la nube, que pueden ser propios o
            provistos por terceros.
          </Typography>
          <Typography mb={1} align="justify">
            Parte de esa infraestructura puede estar establecida en un país diferente al tuyo.
          </Typography>
          <Typography mb={1} align="justify">
            También puede ocurrir que los destinatarios de los datos indicados anteriormente se
            encuentren en un país distinto.
          </Typography>
          <Typography mb={1} align="justify">
            En el caso de que los países receptores de los datos que transferimos no ofrezcan
            niveles adecuados de protección de datos personales, conforme la normativa aplicable en
            la República Argentina, Prestobots adopta medidas para resguardar tus datos, mediante
            cláusulas contractuales o medidas prácticas que imponen las mismas medidas de protección
            que las que se describen en esta Política de Privacidad.
          </Typography>
        </>
      ),
    },
    {
      title: '6. Plazo de almacenamiento de datos',
      content: (
        <>
          <Typography mb={1} align="justify">
            Solo almacenaremos la información personal durante el tiempo necesario para cumplir con
            el propósito para el que se ha recopilado o durante el periodo de prescripción legal de
            posibles responsabilidades legales o contractuales.
          </Typography>
          <Typography mb={1} align="justify">
            Una vez concluido el lapso, los datos serán eliminados o anonimizados de manera tal que
            no pueda ser individualizada ninguna persona, según lo permita la normativa de cada
            país.
          </Typography>
        </>
      ),
    },
    {
      title: '7. Seguridad. Medidas de seguridad respecto a tus datos e información personal',
      content: (
        <>
          <Typography mb={1} align="justify">
            Prestobots ha tomado todas las medidas tecnológicas y organizativas necesarias y de
            acuerdo a los estándares de la industria para proteger tu información personal.{' '}
          </Typography>
          <Typography mb={1} align="justify">
            En la medida en que Prestobots haya cumplido con las normas y adoptado las medidas
            mencionadas en el apartado anterior, no se hace responsable por interceptaciones
            ilegales o violaciones de sus sistemas o bases de datos, ni por su utilización por parte
            de personas no autorizadas.
          </Typography>
        </>
      ),
    },
    {
      title: '8. Ley Aplicable y Jurisdicción',
      content: (
        <Typography variant="body1" align="justify">
          Esta Política de Privacidad se regirá por las leyes aplicables y vigentes en la República
          Argentina. <br />
          Ante cualquier controversia o divergencia relacionada con la interpretación, celebración o
          cumplimiento de las mismas, las partes declaran que se someten a la jurisdicción exclusiva
          de los Tribunales Nacionales Ordinarios con asiento en la Ciudad de Mendoza, renunciando
          expresamente a cualquier otro fuero y/o jurisdicción que pudiera corresponderles.
        </Typography>
      ),
    },
  ];

  return (
    <Box>
      <Box
        sx={{ background: theme.palette.black.main, height: '75px' }}
        display="flex"
        width="100%"
        alignItems="center"
        justifyContent="center"
      >
        <Box mr={2}>
          <img src="/logo512.png" width="50" alt="PrestoBots" />
        </Box>
        <Typography component="h1" variant="h6" noWrap sx={{ color: theme.palette.white.main }}>
          Prestobots
        </Typography>
      </Box>
      <Container maxWidth="md">
        <Box sx={{ my: 5 }}>
          <Typography variant="h4" align="center" gutterBottom>
            Política de Privacidad de prestobots.com
          </Typography>
          <Typography mb={1} align="justify">
            Estas políticas de privacidad están dirigidas a todas las personas que, a modo de
            usuario o consumidores finales, utilicen los servicios de Prestobots.
          </Typography>
          <Typography mb={1} align="justify">
            Prestobots es una empresa que se dedica a la automatización de gestiones on-line a
            través de una variedad de procesos tecnológicos.
          </Typography>
          <Typography mb={1} align="justify">
            Nuestro servicio se integra a plataformas de terceros y, a los fines de poder brindarlo
            en forma correcta, podemos llegar a realizar el tratamiento de algunos datos personales
            de acuerdo a lo que informamos en la presente Política de Privacidad.
          </Typography>
          <Typography mb={1} align="justify" gutterBottom>
            Desde ya, te aseguramos que el tratamiento de tus datos lo hacemos de forma segura e
            informada. Bajo ningún concepto vendemos datos personales a terceros ni los compartimos
            con terceros que no te informemos en la presente Política.
          </Typography>
          {sections.map((section, index) => (
            <Accordion key={index}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
              >
                <Typography variant="h6">{section.title}</Typography>
              </AccordionSummary>
              <AccordionDetails>{section.content}</AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Container>
      <Box sx={{ backgroundColor: '#f8f8f8', padding: '20px 0', textAlign: 'center' }}>
        <Typography variant="body2" color="textSecondary">
          Para preguntas o consultas sobre nuestras Políticas de Privacidad por favor contactarnos a
          nuestro email:{'   '}
          <Link href="mailto:hola@prestobots.com" sx={{ color: 'secondary.main' }}>
            hola@prestobots.com
          </Link>
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ marginTop: '10px' }}>
          Última revisión: 28 noviembre 2024
        </Typography>
      </Box>
    </Box>
  );
};

export default PrivacyPolicy;
